import React from 'react';
import { Card } from 'antd';
import AddTrackedKeywords from './AddTrackedKeywords';
import TrackedKeywordsTable from './TrackedKeywordsTable';
import ChangeLocationAndLanguage from './ChangeLocationAndLanguage';
import { useFetchTrackedKeywordsCountQuery } from './service';
import useGetPlanSettings from '../sales/hooks/useGetPlanSettings';
import useGetCurrentWebsite from '../deepAnalysis/websiteIndexEntry/hooks/useGetCurrentWebsite';


export default function TrackedKeywordsOverview() {
    const { maxKeywords } = useGetPlanSettings();
    const { data: trackedKeywordsCount } = useFetchTrackedKeywordsCountQuery();
    const { website: selectedWebsite } = useGetCurrentWebsite();

    const showAddMoreButton = maxKeywords && !!trackedKeywordsCount && trackedKeywordsCount.keywords_no < maxKeywords;

    if (!selectedWebsite) {
        return null;
    }

    return (
        <Card
            className="keywords-data-overview"
            style={{ marginTop: 20 }}
            title={
                <div className="ant-card-meta-detail">
                    <div className="ant-card-meta-title">Keywords Overview</div>
                    <div className="ant-card-meta-description">{selectedWebsite.domain}</div>
                </div>
            }
            extra={
                <div className="keywords-options card-actions">
                    <ChangeLocationAndLanguage websiteGuid={selectedWebsite.guid} domain={selectedWebsite.domain} locationName={selectedWebsite.settings.location_name} languageCode={selectedWebsite.settings.language_code} />
                    {showAddMoreButton && <AddTrackedKeywords selectedWebsite={selectedWebsite} />}
                </div>
            }
            data-cy="tracked-keywords-overview"
        >
            <div className="keywords-table">
                <TrackedKeywordsTable selectedWebsite={selectedWebsite} />
            </div>
        </Card>
    );
}
